import type { LocationCollectionItem } from '@nuxt/content'

export default function (location: LocationCollectionItem) {
  const { activeLocation } = useMapState()!

  const isActive = computed(() => {
    return location.id === activeLocation.value?.id
  })

  function toggle() {
    if (isActive.value)
      close()

    if (!isActive.value)
      open()
  }

  function open() {
    activeLocation.value = location
  }

  function close() {
    activeLocation.value = undefined
  }

  const addressParts = computed(() => {
    return [
      location.address.street,
      location.address.postalCode,
      location.address.city,
    ].filter(Boolean)
  })

  const address = computed(() => addressParts.value.join(', '))

  const companyName = computed(() => {
    return !location.companyName?.match(location.owner) ? location.companyName : ''
  })

  const articleRoute = location.path.match(/^.*(?=\/locaties)/)?.[0] ?? ''

  return {
    articleRoute,
    toggle,
    activeLocation,
    isActive,
    location,
    address,
    open,
    close,
    companyName,
  }
}
